// ENT-RULE-2: ключ поля формируется из подписи транслитерацией в snake_case.
// Функция общая для формы (ключ виден до сохранения) и сервера.
const TRANSLIT: Record<string, string> = {
  а: 'a', б: 'b', в: 'v', г: 'g', д: 'd', е: 'e', ё: 'e', ж: 'zh', з: 'z', и: 'i', й: 'y',
  к: 'k', л: 'l', м: 'm', н: 'n', о: 'o', п: 'p', р: 'r', с: 's', т: 't', у: 'u', ф: 'f',
  х: 'h', ц: 'ts', ч: 'ch', ш: 'sh', щ: 'sch', ъ: '', ы: 'y', ь: '', э: 'e', ю: 'yu', я: 'ya',
};

export const FIELD_KEY_PATTERN = /^[a-z][a-z0-9_]{0,63}$/;

/** Ключи, которые нельзя занимать пользовательскими полями. */
export const RESERVED_FIELD_KEYS: readonly string[] = ['id', 'title', 'body', 'tags', 'status', 'created_at', 'updated_at'];

export function isValidFieldKey(key: string): boolean {
  return FIELD_KEY_PATTERN.test(key) && !RESERVED_FIELD_KEYS.includes(key);
}

export function fieldKeyFromLabel(label: string, takenKeys: Iterable<string> = []): string {
  const taken = new Set(takenKeys);
  const transliterated = Array.from(label.toLowerCase())
    .map((char) => TRANSLIT[char] ?? char)
    .join('');
  let base = transliterated
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 48);
  if (!/^[a-z]/.test(base)) {
    base = base.length > 0 ? `f_${base}` : 'field';
  }
  if (RESERVED_FIELD_KEYS.includes(base)) {
    base = `${base}_field`;
  }
  let candidate = base;
  let suffix = 2;
  while (taken.has(candidate)) {
    candidate = `${base}_${suffix}`;
    suffix += 1;
  }
  return candidate;
}
